/* eslint-disable babel/camelcase */
export var arrWeekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export var arrWeekdaysShort = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
export var jsonMainSettings = {
  autoUpdate: {
    active: true,
    interval: 5
  }
};
export var jsonTitles = {
  gva: {
    chat: {
      chat_link: 'https://livechat.gva.be',
      subscriptionchat_link: 'https://livechat-aboshop.gva.be'
    }
  },
  hbvl: {
    chat: {
      chat_link: 'https://livechat.hbvl.be',
      subscriptionchat_link: 'https://livechat-aboshop.hbvl.be'
    }
  },
  nieuwsblad: {
    chat: {
      chat_link: 'https://livechat.nieuwsblad.be',
      subscriptionchat_link: 'https://livechat-aboshop.nieuwsblad.be'
    }
  },
  standaard: {
    chat: {
      chat_link: 'https://livechat.standaard.be',
      subscriptionchat_link: 'https://livechat-aboshop.standaard.be'
    }
  },
  limburger: {
    chat: {
      chat_link: 'https://livechat.limburger.nl',
      subscriptionchat_link: 'https://livechat-aboshop.limburger.nl'
    }
  }
};